var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIconBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5625,
    y: 3.75,
    width: 1.875,
    height: 2.5,
    fill: "#272527"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5625,
    y: 3.75,
    width: 1.875,
    height: 2.5,
    fill: "#272527"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.6875,
    width: 5.625,
    height: 1.25,
    fill: "#272527"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.6875,
    width: 5.625,
    height: 1.25,
    fill: "#272527"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.6875,
    y: 8.75,
    width: 5.625,
    height: 1.25,
    fill: "#272527"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.6875,
    y: 8.75,
    width: 5.625,
    height: 1.25,
    fill: "#272527"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3125,
    y: 1.25,
    width: 1.875,
    height: 1.25,
    fill: "#272527"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3125,
    y: 1.25,
    width: 1.875,
    height: 1.25,
    fill: "#272527"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1875,
    y: 2.5,
    width: 1.875,
    height: 1.25,
    fill: "#272527"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1875,
    y: 2.5,
    width: 1.875,
    height: 1.25,
    fill: "#272527"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0625,
    y: 3.75,
    width: 0.9375,
    height: 1.25,
    fill: "#272527"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0625,
    y: 3.75,
    width: 0.9375,
    height: 1.25,
    fill: "#272527"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0625,
    y: 5,
    width: 0.9375,
    height: 1.25,
    fill: "#272527"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0625,
    y: 5,
    width: 0.9375,
    height: 1.25,
    fill: "#272527"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 1.875,
    height: 1.25,
    transform: "matrix(1 0 0 -1 10.3125 8.75)",
    fill: "#272527"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 1.875,
    height: 1.25,
    transform: "matrix(1 0 0 -1 10.3125 8.75)",
    fill: "#272527"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 1.875,
    height: 1.25,
    transform: "matrix(1 0 0 -1 12.1875 7.5)",
    fill: "#272527"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 1.875,
    height: 1.25,
    transform: "matrix(1 0 0 -1 12.1875 7.5)",
    fill: "#272527"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 0.9375,
    height: 1.25,
    transform: "matrix(1 0 0 -1 14.0625 6.25)",
    fill: "#272527"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 0.9375,
    height: 1.25,
    transform: "matrix(1 0 0 -1 14.0625 6.25)",
    fill: "#272527"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 0.9375,
    height: 1.25,
    transform: "matrix(1 0 0 -1 14.0625 5)",
    fill: "#272527"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 0.9375,
    height: 1.25,
    transform: "matrix(1 0 0 -1 14.0625 5)",
    fill: "#272527"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 4.6875,
    y: 8.75,
    width: 1.875,
    height: 1.25,
    transform: "rotate(-180 4.6875 8.75)",
    fill: "#272527"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 4.6875,
    y: 8.75,
    width: 1.875,
    height: 1.25,
    transform: "rotate(-180 4.6875 8.75)",
    fill: "#272527"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 2.8125,
    y: 7.5,
    width: 1.875,
    height: 1.25,
    transform: "rotate(-180 2.8125 7.5)",
    fill: "#272527"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 2.8125,
    y: 7.5,
    width: 1.875,
    height: 1.25,
    transform: "rotate(-180 2.8125 7.5)",
    fill: "#272527"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 0.9375,
    y: 6.25,
    width: 0.9375,
    height: 1.25,
    transform: "rotate(-180 0.9375 6.25)",
    fill: "#272527"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 0.9375,
    y: 6.25,
    width: 0.9375,
    height: 1.25,
    transform: "rotate(-180 0.9375 6.25)",
    fill: "#272527"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 0.9375,
    y: 5,
    width: 0.9375,
    height: 1.25,
    transform: "rotate(-180 0.9375 5)",
    fill: "#272527"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 0.9375,
    y: 5,
    width: 0.9375,
    height: 1.25,
    transform: "rotate(-180 0.9375 5)",
    fill: "#272527"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 1.875,
    height: 1.25,
    transform: "matrix(-1 -1.16564e-07 -6.55671e-08 1 4.6875 1.25)",
    fill: "#272527"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 1.875,
    height: 1.25,
    transform: "matrix(-1 -1.16564e-07 -6.55671e-08 1 4.6875 1.25)",
    fill: "#272527"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 1.875,
    height: 1.25,
    transform: "matrix(-1 -1.16564e-07 -6.55671e-08 1 2.8125 2.5)",
    fill: "#272527"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 1.875,
    height: 1.25,
    transform: "matrix(-1 -1.16564e-07 -6.55671e-08 1 2.8125 2.5)",
    fill: "#272527"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 0.9375,
    height: 1.25,
    transform: "matrix(-1 -1.16564e-07 -6.55671e-08 1 0.9375 3.75)",
    fill: "#272527"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 0.9375,
    height: 1.25,
    transform: "matrix(-1 -1.16564e-07 -6.55671e-08 1 0.9375 3.75)",
    fill: "#272527"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 0.9375,
    height: 1.25,
    transform: "matrix(-1 -1.16564e-07 -6.55671e-08 1 0.9375 5)",
    fill: "#272527"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 0.9375,
    height: 1.25,
    transform: "matrix(-1 -1.16564e-07 -6.55671e-08 1 0.9375 5)",
    fill: "#272527"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconBlack);
export default __webpack_public_path__ + "static/media/Eye-Icon-Black.d89f4a697a08354d50e1a7a4159c749c.svg";
export { ForwardRef as ReactComponent };